import React from "react";
import { PartialProgram } from "@/common/course/types";
import useWebview from "@/webview/useWebview";
import useTranslations from "@/i18n/useTranslations";

interface FullProgramCTAProps {
  items: PartialProgram[];
}

function FullProgramCTA({ items }: FullProgramCTAProps) {
  const t = useTranslations("Program");
  const tCommon = useTranslations("ProductCompare");

  const { getUrl } = useWebview();
  const currentUrl = getUrl("/" + items[0]?.marketingUrl) || "";

  if (items.length === 1) {
    return (
      <div className="bg-primary-500 py-14 px-4 md:px-16">
        <h2 className="text-putty-500 font-light text-2xl md:text-4xl mt-0 pt-0 mb-8">
          {t("thisCourseIsPartOf")}
          <br />
          <span className="font-extrabold">
            {t("programSuffix", {
              title: items[0].title,
              type: items[0].type ?? "",
            })}
          </span>
        </h2>
        <a href={currentUrl}>
          <button className="text-center content-center items-center min-w-full md:min-w-32 py-2 justify-center disabled:opacity-25 rounded-full px-6 bg-brand text-white border-2 border-brand hover:bg-white hover:text-brand hover:border-brand">
            <span>{tCommon("learnMore")}</span>
          </button>
        </a>
      </div>
    );
  }

  return (
    <div className="bg-putty-400 py-14 px-4 md:px-16">
      <div className="grid grid-cols-1 md:grid-cols-2 md:gap-6">
        <div className="gap-4 place-content-center">
          <h2 className="text-4xl md:text-6xl italic text text-secondary-500 font-black font-inter mt-0 sm:pt-0">
            {t("getTheFullProgram")}
          </h2>
          <h3 className="text-lg font-bold font-inter leading-9">
            {t("thisCourseIsPartOfFollowing")}
          </h3>
        </div>
        <div className="grid-cols-1 place-content-center">
          <ul className="md:gap-6 !list-none">
            {items.map((item, index) => (
              <li
                key={index}
                className={`font-inter underline text-base ${index !== items.length - 1 ? "mb-4" : ""}`}
              >
                <a href={getUrl("/" + item.marketingUrl)} target="_blank">
                  {t("programInTitle", {
                    type: item.type ?? "",
                    title: item.title,
                  })}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default FullProgramCTA;
